export default {
  Whisper: "Whisper",
  HiddenMode: "Hidden Mode",
  Camera: "Camera",
  Microphone: "Microphone",
  Join: "Join",
  ValidatingToken: "Validating Token",
  WhisperSettings: "Whisper Settings",
  SomeoneElseAlreadyObeserving: "Someone else is already observing the call!",
  Copy: "Copy",
  Copied: "Copied!",
  CopyFailed: "Copy Failed!",
  SupervisorLink: "Supervisor Link:",
  Close: "Close",
  LocalURLBaseNotSet: "LOCAL_URL_BASE is not set in admin panel configuration.",
};
